export const TOP_AIRPORTS = [
  'PEK', 'IST', 'SVO', 'DEL', 'URC',
  'ICN', 'DXB', 'KUL', 'CCU', 'YYZ',
];

export const AIRPORT_NAMES = {
  PEK: 'Beijing Capital Intl',
  IST: 'Istanbul Airport',
  SVO: 'Moscow Sheremetyevo',
  DEL: 'Indira Gandhi Intl',
  URC: 'Ürümqi Diwopu Intl',
  ICN: 'Seoul Incheon Intl',
  DXB: 'Dubai International',
  KUL: 'Kuala Lumpur Intl',
  CCU: 'Kolkata Netaji Subhas',
  YYZ: 'Toronto Pearson Intl',
};
